




















import React from "react";
import "../../styles/FreightForwarding.css";
import freightImage from "../../images/freightforwarding-slider.jpg";
import freight1 from "../../assets/freight1.png";
import freight2 from "../../assets/freight2.png";
import shipIcon from "../../assets/service-icon.png"; // Import the service icon
import { Link } from "react-router-dom";

const PuyvastFreightForwarding = () => {
  return (
    <div className="puyvast-freight-container">
      {/* Image Slider - Full width like homepage */}
      <div className="puyvast-freight-image-slider">
        <img src={freightImage} alt="Freight Forwarding Slider" />
      </div>

      {/* Main Content Container */}
      <div className="puyvast-freight-content">
        {/* Content Card with title inside */}
        <div className="puyvast-freight-card">
          {/* Title with Icon - Similar to Granite page */}
          <div className="puyvast-freight-title-header">
            <img src={shipIcon} alt="Freight Service" className="puyvast-freight-title-icon puyvast-rotate-on-hover" />
            <h3 className="puyvast-freight-title-text">Freight Forwarding & Custom Clearance</h3>
          </div>
          
          {/* Left Side - Images */}
          <div className="puyvast-card-left">
            <div className="puyvast-freight-image-container puyvast-first-image">
              <img src={freight1} alt="Freight Cargo" className="puyvast-freight-img" />
            </div>
            <div className="puyvast-freight-image-container puyvast-second-image">
              <img src={freight2} alt="Custom Clearance" className="puyvast-freight-img" />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="puyvast-card-right">
            <p className="puyvast-freight-text">
              Our Freight Forwarding & Custom Clearance is led by highly qualified and experienced personnel in liner & container operating professions with more than 25 years of cumulative experience in this field.
            </p>
            <p className="puyvast-freight-text">
              Under their supervision and guidance, the team uniquely acts as a "carrier to shippers" and "shipper to carriers." Our worldwide connections, accompanied by our efficient services, help us maintain our position in the market.
            </p>
            
            {/* Services section with blue background - similar to destinations in Granite */}
            <div className="puyvast-freight-blue-header">
              <img src={shipIcon} alt="Services" className="puyvast-freight-header-icon puyvast-rotate-on-hover" />
              <div className="puyvast-freight-vertical-line"></div>
              <h3 className="puyvast-freight-header-title">A partial list of our services include:</h3>
            </div>
            <ul className="puyvast-services-list">
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🚢</span> 
                <span className="puyvast-service-text">Sea Cargo (LCL / FCL)</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">✈️</span> 
                <span className="puyvast-service-text">Air Cargo</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🚢</span> 
                <span className="puyvast-service-text">ODC / Project Cargo (Sea, Air & Road)</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🔧</span> 
                <span className="puyvast-service-text">Special Equipment Stuffing + Lashing & Chocking</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🚢</span> 
                <span className="puyvast-service-text">Break Bulk Forwarding</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🧪</span> 
                <span className="puyvast-service-text">ISO Tank / Liquid Bulk</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🚚</span> 
                <span className="puyvast-service-text">Land Transportation</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">📝</span> 
                <span className="puyvast-service-text">Custom Clearance</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🏭</span> 
                <span className="puyvast-service-text">Warehousing</span>
              </li>
              <li>
                <span className="puyvast-service-icon puyvast-moving-ship">🚪</span> 
                <span className="puyvast-service-text">Door-to-Door Services</span>
              </li>
            </ul>
            
            <p className="puyvast-freight-text">
              With our global network & local knowledge that gives us the edge, and you the confidence that your cargo is in safe hands. With our experience and enthusiasm we offer tailor made solutions that matches and exceeds your requirements and expectations.
            </p>
            <p className="puyvast-freight-text">
              We provide shipping options that will meet your critical deadlines at the most cost efficient and reliable way either by sea, air or land.
            </p>
          </div>
        </div>

        {/* Download Section Card */}
        <div className="puyvast-freight-card puyvast-download-card">
          <div className="puyvast-download-left">
            <h3 className="puyvast-download-title">DOWNLOAD</h3>
            <a href="/FreightForwarding_Presentation.ppt" download className="puyvast-download-btn">
              <img src="/images/ppt-icon.png" alt="PPT Icon" className="puyvast-ppt-icon" />
            </a>
          </div>

          <div className="puyvast-download-right">
            <h3 className="puyvast-contact-title">Contact Us:</h3>
            <p className="puyvast-contact-info"><strong>Puyvast Logistics PVT LTD</strong></p>
            <p className="puyvast-contact-info">Laxmi Towers, 3rd Floor, No. 45/8, Dr. Radhakrishnan Salai, Mylapore, Chennai, India - 600 004</p>
            <p className="puyvast-contact-info">Office: +91 44 42177103, 28116652 ｜ Fax: +91 44 42177106</p>
            <p className="puyvast-contact-info">Email: <a href="mailto:frtfwd@puyvast.co.in" className="puyvast-email-link">frtfwd@puyvast.co.in</a></p>
            <p className="puyvast-contact-info"><strong>Branches:</strong> Visakhapatnam * Krishnapatnam * SriCity-SEZ * Nellore * Ongole * Kakinada</p>
          </div>
        </div>
      </div>

      {/* Footer - Same as Granite page but with unique class names */}
      <footer className="puyvast-footer">
        <div className="puyvast-footer-container">
          {/* Left Section - CIN & Links */}
          <div className="puyvast-footer-left">
            <p>CIN Number: U63090KA1997PTC022102</p>
            <p>
              <Link to="/privacy-statement" className="puyvast-footer-link">Privacy Statement</Link> |
              <Link to="/terms-of-use" className="puyvast-footer-link"> Terms Of Use</Link>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="puyvast-footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="puyvast-footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PuyvastFreightForwarding;